module.exports = __webpack_public_path__ + "static/media/Icons-1.6b34b83d.svg";